{
  "version": 1,
  "asset_id": "9bd57299-de0e-4a1a-b91b-bf0dee12aa75",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/9bd57299-de0e-4a1a-b91b-bf0dee12aa75/logo-sirelo.png",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/9bd57299-de0e-4a1a-b91b-bf0dee12aa75/logo-sirelo.png",
  "original_filename": "logo-sirelo.png",
  "size": 10705,
  "content_type": "image/png",
  "created_at": "2026-09-04T14:19:05Z"
}
